import React from "react";
import { NavLink } from "react-router-dom";
import Icon from "../Icon";
import * as S from "./styled";

interface IProps {
  icon?: any;
  text: string;
  linkTo: string;
  target: string;
}

const FloatingBanner = ({ icon, text, linkTo, target }: IProps) => {
  return (
    <S.FloatingBanner>
      <NavLink to={linkTo} target={target}>
        {icon && (
          <Icon>
            <img src={icon} alt="floating icon" />
          </Icon>
        )}
        <p className={icon ? "active" : "default"}>{text}</p>
      </NavLink>
    </S.FloatingBanner>
  );
};

export default FloatingBanner;
